<template>
  <div class="suggest-products" v-if="dataLoaded && products && products.length"> 
    <div class="title-box">{{ android ? '随便逛逛' : title}}</div>
    <div class="products flex-wrap">
      <product 
        v-for="(item, index, i) in products" 
        :source="source"
        :data="item" 
        :miniEnv="miniEnv"
        :businessCase="businessCase"
        :index="index"
        :float="(index >=0 ) ? index + 1 : (i + 1)"/>
    </div>
  </div>
</template>

<script>
  import product from '@/components/list-v1'
  import axios from '@/axios-mock'
  import { lazyload } from '@/lazyload'
  import { android } from '@beastshop/browser'
  import {
    getEnv
  } from '@/sdk'

  export default {
    name: 'suggest-products',
    props: {
      offset: {
        default: 0
      },
      limit: {
        default: 20
      },
      source: {
        default: 'CART'
      },
      miniEnv: {
        default: false
      },
      title: {
        default: '你可能喜欢'
      },
      productId: {
        default: ''
      },
      orderId: {
        default: ''
      }
    },
    data () {
      return {
        android: android(),
        dataLoaded: false,
        products: [],
        icon: '//img.thebeastshop.com/apppictures/2017-12-22/c57d173ff71cb42b64c9fb5e21cc6c07.png',
        border: '//img.thebeastshop.com/apppictures/2017-12-22/befe87ce675f2eeac6669bb98ec0eda4.png',
        businessCase: '猜你喜欢',
        sdk: null,
        env: ''
      }
    },
    created () {
      getEnv()
      .then(sdk => {
        this.sdk = sdk
        this.env = this.sdk.adapter.env
        this.getProducts(sdk)
        .then(({ data }) => {
          this.products = data
          this.dataLoaded = true
          this.$nextTick(() => {
            lazyload()
            const exposurer = new this.$exposure((node) => {
              console.log(node, '曝光啦')
              const recommendEngine = node.getAttribute('data-recommend') || ''
              const bu = recommendEngine ? `猜你喜欢-${recommendEngine}`: '猜你喜欢'
              sa.track('CommodityExposure', {
                commodity_spu_id: node.getAttribute('data-id'),
                commodity_name: node.getAttribute('data-name'),
                activity_type: sa.getActivity(node.getAttribute('data-labels') || []),
                original_price: node.getAttribute('data-rawprice'),
                discount_price: node.getAttribute('data-price'),
                position_number: node.getAttribute('data-index') - 0 + 1,
                business_case: bu
              })
            })
            
            exposurer.observe('.list-product-v1')
          })
        })
        .catch(() => {
          
        })
      })
    
    },
    components: {
      product
    },
    methods: {
      getProducts (sdk) {
        // return Promise.resolve({ data:require('./test/data.js')})
        let query = ""
        if(this.source === 'CART') {
          query = `offset=${this.offset}&limit=${this.limit}&source=${this.source}`
        }
        else if(this.source === 'PRODUCT' && this.productId) {
          query = `productId=${this.productId}&offset=${this.offset}&limit=${this.limit}&source=${this.source}`
        }
        else if(this.source === 'ORDER') {
          query = `orderId=${this.orderId}&offset=${this.offset}&limit=${this.limit}&source=${this.source}`
        }
        else {
          query = `offset=${this.offset}&limit=${this.limit}&source=${this.source}`
        }
        console.log(this.source,'sss')
        return sdk.request({
          url: `/app/product/suggest?${query}`,
        })
      }
    }
  }
</script>

<style lang="stylus">
  @import '../../common/styl/global.styl'
  .suggest-products
    background #fff
    .products
      &.flex-wrap
        display flex
        flex-wrap wrap
        justify-content space-between
      &::after
        content ''
        clear both
        font-size 0
        height 0
        line-height 0
        display block
    .title-box
      width 100%
      padding rem(28) 0 rem(20)
      text-align center
      font-weight bolder
      box-sizing border-box
      font-size rem(20)
      color #000
</style>




// WEBPACK FOOTER //
// index.vue?71437728